import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const reviews = [{
  id: 1,
  name: 'Mariana R.',
  rating: 5,
  text: 'Muy buen servicio, rápido y amable. Se nota que hay amor puesto en lo que hacen. Volvemos seguro.'
}, {
  id: 2,
  name: 'Carlos M.',
  rating: 5,
  text: 'Fuimos en familia y quedamos encantados. El patio es precioso, la comida abundante y el show de folclore fue increíble.'
}, {
  id: 3,
  name: 'Sofía P.',
  rating: 5,
  text: 'Lindo ambiente y rica comida. El sándwich de vacío es una barbaridad. Definitivamente el mejor lugar de Gálvez.'
}, {
  id: 4,
  name: 'Rodrigo V.',
  rating: 5,
  text: 'La atención de Mary es de otra categoría. Te hacen sentir como en casa desde que llegás. El show estuvo excelente.'
}];
export function Reviews() {
  const scrollRef = useRef<HTMLDivElement>(null);
  return <section className="py-24 bg-matambrito-charcoal relative overflow-hidden" data-id="element-318">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-319">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16" data-id="element-320">
          <div className="max-w-2xl" data-id="element-321">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-matambrito-cream mb-4" data-id="element-322">
              Lo que dice la gente que ya vivió la{' '}
              <span className="text-matambrito-gold" data-id="element-323">experiencia</span>
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-xl text-matambrito-beige font-light" data-id="element-324">
              +236 reseñas en Google · 4.5 estrellas
            </motion.p>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="flex items-center gap-3 bg-white/5 border border-white/10 px-6 py-3 rounded-full shrink-0" data-id="element-325">
            <div className="flex text-matambrito-gold" data-id="element-326">
              {[...Array(5)].map((_, i) => <Star key={i} className={`w-5 h-5 ${i === 4 ? 'fill-matambrito-gold/50' : 'fill-current'}`} data-id="element-327" />)}
            </div>
            <span className="text-matambrito-cream font-bold text-lg" data-id="element-328">4.5</span>
            <span className="text-matambrito-beige/60" data-id="element-329">/ 5</span>
          </motion.div>
        </div>

        {/* Horizontal Scrollable Container */}
        <div ref={scrollRef} className="flex overflow-x-auto gap-6 pb-8 hide-scrollbar snap-x snap-mandatory" data-id="element-330">
          {reviews.map((review, index) => <motion.div key={review.id} initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="min-w-[300px] md:min-w-[400px] bg-matambrito-black p-8 rounded-2xl border border-white/5 snap-center relative group hover:border-matambrito-gold/20 transition-colors" data-id="element-331">
              <Quote className="absolute top-6 right-6 w-10 h-10 text-white/5 group-hover:text-matambrito-gold/10 transition-colors" data-id="element-332" />

              <div className="flex text-matambrito-gold mb-6" data-id="element-333">
                {[...Array(review.rating)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-334" />)}
              </div>

              <p className="text-matambrito-beige/90 text-lg leading-relaxed mb-8 font-light italic" data-id="element-335">
                "{review.text}"
              </p>

              <div className="flex items-center gap-3 mt-auto" data-id="element-336">
                <div className="w-10 h-10 rounded-full bg-matambrito-charcoal flex items-center justify-center text-matambrito-cream font-bold font-serif border border-white/10" data-id="element-337">
                  {review.name.charAt(0)}
                </div>
                <span className="text-matambrito-cream font-medium" data-id="element-338">
                  {review.name}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}